module.exports = __webpack_public_path__ + "img/steam.77aec172.png";